export enum TemplatesForInspirationTileVariant {
  HALF = 'half',
  FULL = 'full',
}

export const TEMPLATES_THUMBNAIL_COUNT_HALF = 3;
export const TEMPLATES_THUMBNAIL_COUNT_FULL = 6;
export const MIN_TEMPLATES_TO_RENDER = 3;

export interface RecommendedTemplate {
  hashedId: string;
  previewUrl: string;
  pageHashedId: string;
}

export interface TemplatesForInspirationTileProps {
  chatId: string;
  hashedId: string;
  variant: TemplatesForInspirationTileVariant;
  showCollapsed: boolean;
}
